<template>
  <div class="icon"
       @click="onClick">
    <div class="icon__top"></div>
    <div class="icon__bottom"></div>
  </div>
</template>

<script>
  import AttributeReport from '../features/reports/attribute/AttributeReport'

/**
   * Icon for Custom List on {@link AttributeReport}
   */
export default {
  name: 'BaseOverlapIcon',
  methods: {
    onClick () {
      this.$emit('overlap-click')
    }
  }
}
</script>

<style scoped lang="scss">
  .icon {
    position: relative;
    width: 16px;
    height: 16px;
    color: $rfx-dark-march;

    &:hover {
      color: $rfx-bright-turquoise;
      cursor: pointer;
    }

    &__bottom,
    &__top {
      position: absolute;
      width: 8px;
      height: 8px;
      border: 2px solid currentColor;
      border-radius: 50%;
    }

    &__bottom {
      top: 6px;
      left: 1px;
    }

    &__top {
      top: 1px;
      left: 7px;
    }
  }
</style>
